import ReactDOM from "react-dom";
import BitsApp from "./BitsApp";
import "./styles/Index.css";
import "./styles/swal.css";
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: "https://bits-apollo-produccion.azurewebsites.net/graphql",    
  //  uri: "http://localhost:5000/graphql",
  }),
});

if ("Notification" in window && Notification.permission !== "granted") {
  Notification.requestPermission().then(() => {
    console.log("Notification granted")
  })
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <BitsApp />
  </ApolloProvider>,
  document.getElementById("root")
);
